/**
 * EHCP document upload policy for SEN status E.
 * Schools do not always require an EHCP file to confirm the section.
 */
export const isEhcpUploadRequiredToConfirm = false;

/**
 * Whether save/confirm is allowed when SEN status is EHCP (E).
 * @param {object|File|null|undefined} _ehcpFile Present or absent; upload is optional.
 */
export const canConfirmEhcpSenStatus = (_ehcpFile) => !isEhcpUploadRequiredToConfirm;
